module.exports = __webpack_public_path__ + "media/images/emblems/Porza-coat_of_arms-77d51c5b4180cf9e93801f6274f93c44.svg";